import React from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

function Footer() {
    return (
        <footer className="footer ">
            <div className="row container">
                <div className="offset-by-two two columns footer-column">
                    <p className="footer-subtitle">Explorar</p>
                    <ul className="footer-menu">
                        <li>
                            <Link to="/comprar">Comprar</Link>
                        </li>
                        <li>
                            <Link to="/comer">Comer</Link>
                        </li>
                        <li>
                            <Link to="/contratar">Contratar</Link>
                        </li>
                    </ul>
                </div>
                <div className="two columns footer-column">
                    <p className="footer-subtitle">Nosotros</p>
                    <ul className="footer-menu">
                        <li>
                            <a href="/nosotros">Nosotros</a>
                        </li>
                        <li>
                            <Link to="/vender">Vender</Link>
                        </li>
                        <li>
                            <Link className="itemBadge" to="/pro" target="_blank">PRO</Link>
                        </li>
                    </ul>
                </div>
                <div className="two columns footer-column">
                    <p className="footer-subtitle">Legal</p>
                    <ul className="footer-menu">
                        <li>
                            <a href="/privacidad">Privacidad</a>
                        </li>
                        <li>
                            <a href="/terminos">Términos</a>
                        </li>
                        <li>
                            <a href="/cookies">Cookies</a>
                        </li>
                    </ul>
                </div>
                <div className="two columns footer-column">
                    <p className="footer-subtitle">Social</p>
                    <ul className="footer-menu">
                        <li>
                            <a href="https://www.facebook.com/okkipuntoco" target="_blank">
                                Facebook
       </a>
                        </li>
                        <li>
                            <a href="https://twitter.com/okkico" target="_blank">
                                Twitter
       </a>
                        </li>
                        <li>
                            <a href="https://instagram.com/okkico" target="_blank">
                                Instagram
       </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="footer-bottom">
                <p className="footer-signature">
                    © 2020 <span><svg width="34" height="10" viewBox="0 0 34 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.97076 0.00595342C2.2269 0.00595342 0 2.24238 0 4.99798C0 7.75359 2.2269 9.99002 4.97076 9.99002C7.71462 9.99002 9.94152 7.75359 9.94152 4.99798C9.94152 2.24238 7.71462 0.00595342 4.97076 0.00595342ZM4.97076 7.19448C3.76784 7.19448 2.78363 6.20606 2.78363 4.99798C2.78363 3.78991 3.76784 2.80149 4.97076 2.80149C6.17368 2.80149 7.15789 3.78991 7.15789 4.99798C7.15789 6.20606 6.17368 7.19448 4.97076 7.19448ZM29.3175 2.482C29.914 1.99278 30.0035 1.11418 29.5164 0.515141C29.0292 -0.0839031 28.1544 -0.17376 27.5579 0.315459L24.3865 2.9213C24.2573 3.03112 24.0585 2.93128 24.0585 2.77154V1.44366C24.0585 0.694854 23.4819 0.0458897 22.7363 0.00595342C21.9409 -0.0339828 21.2749 0.604997 21.2749 1.40372V8.55231C21.2749 9.30112 21.8515 9.95008 22.5971 9.99002C23.3924 10.03 24.0585 9.39097 24.0585 8.59225V7.22443C24.0585 7.0547 24.2573 6.96485 24.3865 7.07467L27.5579 9.68051C27.8164 9.89018 28.1246 10 28.4427 10C28.8503 10 29.2479 9.82029 29.5164 9.49081C30.0035 8.89177 29.914 8.01317 29.3175 7.52395L26.6333 5.31747C26.4345 5.15773 26.4345 4.85821 26.6333 4.69846L29.3175 2.482ZM32.6082 0.00595342C31.8427 0.00595342 31.2164 0.634949 31.2164 1.40372V8.59225C31.2164 9.36102 31.8427 9.99002 32.6082 9.99002C33.3737 9.99002 34 9.36102 34 8.59225V1.40372C34 0.634949 33.3737 0.00595342 32.6082 0.00595342ZM19.376 2.482C19.9725 1.99278 20.062 1.11418 19.5749 0.515141C19.0877 -0.0839031 18.2129 -0.17376 17.6164 0.315459L14.445 2.9213C14.3158 3.03112 14.117 2.93128 14.117 2.77154V1.44366C14.117 0.694854 13.5403 0.0458897 12.7947 0.00595342C11.9994 -0.0339828 11.3333 0.604997 11.3333 1.40372V8.55231C11.3333 9.30112 11.9099 9.95008 12.6556 9.99002C13.4509 10.03 14.117 9.39097 14.117 8.59225V7.22443C14.117 7.0547 14.3158 6.96485 14.445 7.07467L17.6164 9.68051C17.8749 9.89018 18.183 10 18.5012 10C18.9088 10 19.3064 9.82029 19.5749 9.49081C20.062 8.89177 19.9725 8.01317 19.376 7.52395L16.6918 5.31747C16.493 5.15773 16.493 4.85821 16.6918 4.69846L19.376 2.482Z" fill="#888888" />
                    </svg>
                    </span>, Todos los derechos reservados.
    </p>
            </div>
        </footer>
    );
}

export default Footer;
